import { ModalCloseButton as ChakraModalCloseButton } from "@chakra-ui/react";

export const ModalCloseButton = ChakraModalCloseButton;
